// MEGA MENU DESKTOP FUNCTIONALITY
document.addEventListener("DOMContentLoaded", function () {
  initMegaMenu();
  setupEventListeners();

  const firstNonStandardOption = document.querySelector(
    ".mega-menu-option:not(.standard-option):not(.mobile)"
  );
  if (firstNonStandardOption) {
    firstNonStandardOption.classList.add("show-chevron");
  }
  const firstStandard = document.querySelector(".standard-option.desktop");
  const firstStandardMobile = document.querySelector(".standard-option.mobile");
  if (firstStandard) {
    firstStandard.style.borderTop = "1px #1a1a1e solid";
    firstStandard.style.paddingTop = "20px";
  }
  if (firstStandardMobile) {
    firstStandardMobile.style.borderTop = "1px lightgrey solid";
    firstStandardMobile.style.paddingTop = "20px";
  }
});

function initMegaMenu() {
  const liContainers = document.querySelectorAll(
    ".li-container.mega-menu-container.mega-menu-wrapper"
  );
  liContainers.forEach((liContainer) => {
    const menuOptions = liContainer.querySelectorAll(
      ".mega-menu-option:not(.mobile)"
    );
    const menuContents = liContainer.querySelectorAll(
      ".mega-menu-right-content"
    );
    let firstHover = true;
    let lastVisibleContent = null;
    let hoverTimeout;

    menuOptions.forEach((option) => {
      option.addEventListener("mouseover", (event) => {
        clearTimeout(hoverTimeout);
        hoverTimeout = setTimeout(() => {
          toggleMenuContents(event.target.getAttribute("data-option"));
        }, 200);
      });

      option.addEventListener("mouseleave", () => {
        clearTimeout(hoverTimeout);
      });
    });

    liContainer.addEventListener("mouseover", () => {
      if (firstHover) {
        const associatedContent = liContainer.querySelector(
          '.mega-menu-right-content[data-content="adult"]'
        );
        if (associatedContent) {
          menuContents.forEach((content) => {
            content.style.display = "none";
          });
          associatedContent.style.display = "block";
          firstHover = false;
          lastVisibleContent = associatedContent;
        }
      } else if (lastVisibleContent) {
        menuContents.forEach((content) => {
          content.style.display = "none";
        });
        lastVisibleContent.style.display = "block";
      }
    });

    liContainer.addEventListener("mouseover", () => {
      if (firstHover) {
        const associatedContent = liContainer.querySelector(
          '.mega-menu-right-content[data-content="adult"]'
        );
        if (associatedContent) {
          menuContents.forEach((content) => {
            content.style.display = "none";
          });
          associatedContent.style.display = "block";
          firstHover = false;
          lastVisibleContent = associatedContent;
        }
      } else if (lastVisibleContent) {
        menuContents.forEach((content) => {
          content.style.display = "none";
        });
        lastVisibleContent.style.display = "block";
      }
    });

    function toggleMenuContents(optionIndex) {
      const contentToShow = liContainer.querySelector(
        `.mega-menu-right-content[data-content="${optionIndex}"]`
      );
      if (optionIndex !== "standard") {
        hideMenuContents();
        contentToShow.style.display = "block";
        contentToShow.style.visibility = "visible";
        lastVisibleContent = contentToShow;
      } else if (lastVisibleContent) {
        hideMenuContents(lastVisibleContent);
        lastVisibleContent.style.display = "block";
        contentToShow.style.visibility = "visible";
      }
    }

    function hideMenuContents(excludedContent) {
      menuContents.forEach((content) => {
        if (content !== excludedContent) {
          content.style.display = "none";
          content.style.visibility = "hidden";
        }
      });
    }
  });
}

function setMegaMenuPosition() {
  const megaMenuContents = document.querySelectorAll(".mega-menu-content");
  const megaMenuWrapper = document.querySelector(".header__inline-menu");

  if (megaMenuWrapper) {
    megaMenuContents.forEach((megaMenuContent) => {
      const liContainer = megaMenuContent.closest(
        ".li-container.mega-menu-container.mega-menu-wrapper"
      );
      const rect = liContainer.getBoundingClientRect();
      const leftValue = rect.left;

      megaMenuContent.style.visibility = "hidden";
      megaMenuContent.style.left = `${-leftValue}px`;
      megaMenuContent.style.width = `100vw`;
      megaMenuContent.style.visibility = "visible";
    });
  }
}

function setupEventListeners() {
  const parentLis = document.querySelectorAll(".mega-menu-wrapper > li");

  if (!parentLis.length) return;

  parentLis.forEach((parentLi) => {
    parentLi.addEventListener("mouseenter", updateMegaMenuPosition);
    parentLi.addEventListener("mouseleave", updateMegaMenuPosition);
  });

  window.addEventListener("resize", setMegaMenuPosition);
}

function updateMegaMenuPosition() {
  setTimeout(() => {
    setMegaMenuPosition();
  }, 100);
}

// MEGA MENU DESKTOP STYLING
document
  .querySelectorAll(".mega-menu-option:not(.standard-option):not(.mobile)")
  .forEach((option) => {
    let chevronTimeout;

    option.addEventListener("mouseover", (e) => {
      const target = e.target;
      const contentKey = target.dataset.option;

      clearTimeout(chevronTimeout);
      chevronTimeout = setTimeout(() => {
        document
          .querySelectorAll(".mega-menu-option:not(.mobile)")
          .forEach((otherOption) => {
            otherOption.classList.remove("show-chevron");
          });

        target.classList.add("show-chevron");

        document
          .querySelectorAll(".mega-menu-right-content")
          .forEach((content) => {
            if (content.dataset.content === contentKey) {
              content.style.display = "block";
            } else {
              content.style.display = "none";
            }
          });
      }, 200);
    });

    option.addEventListener("mouseleave", () => {
      clearTimeout(chevronTimeout);
    });
  });

document
  .querySelector(".mega-menu-content")
  .addEventListener("mouseleave", () => {
    document.querySelectorAll(".mega-menu-right-content").forEach((content) => {
      content.style.display = "none";
    });

    document
      .querySelectorAll(".mega-menu-option:not(.standard-option):not(.mobile)")
      .forEach((option) => {
        option.classList.remove("show-chevron");
      });
  });

// DROPDOWN MOBILE MENU FUNCTIONALITY
const drawer = document.getElementById("menu-drawer");
const contentContainer = document.querySelector(".menu-drawer__content");
const hamburgerButton = document.querySelector(".hamburger");
const closeButton = document.querySelector(".close");
const backButton = document.createElement("button");
const storedDropdownMenus = {};
backButton.innerText = "Back";
backButton.classList.add("back-button");
backButton.style.display = "none";
contentContainer.appendChild(backButton);
const menuOptions = document.querySelectorAll(".dropdown-header-mobile");
menuOptions.forEach((menuOption, index) => {
  menuOption.addEventListener("click", (event) => {
    event.preventDefault();
    const dropdownMenu = menuOption.nextElementSibling;
    const mainMenu = document.querySelector(".menu-drawer__navigation");
    const spanText = menuOption.querySelector("span").innerText;
    let lowercaseSpanText = spanText.toLowerCase();
    let capitalizedFirstLetterSpanText =
      lowercaseSpanText.charAt(0).toUpperCase() + lowercaseSpanText.slice(1);
    backButton.innerHTML = "";
    backButton.insertAdjacentHTML(
      "beforeend",
      `<svg width="8" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right:10px;"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.8839 1.11612C13.372 1.60427 13.372 2.39573 12.8839 2.88388L3.76777 12L12.8839 21.1161C13.372 21.6043 13.372 22.3957 12.8839 22.8839C12.3957 23.372 11.6043 23.372 11.1161 22.8839L1.11612 12.8839C0.881696 12.6495 0.75 12.3315 0.75 12C0.75 11.6685 0.881696 11.3505 1.11612 11.1161L11.1161 1.11612C11.6043 0.627961 12.3957 0.627961 12.8839 1.11612Z" fill="#FF0000"/></svg>${capitalizedFirstLetterSpanText}`
    );
    if (dropdownMenu) {
      storedDropdownMenus[spanText] = dropdownMenu;
    }
    mainMenu.style.display = "none";
    contentContainer.appendChild(storedDropdownMenus[spanText]);
    storedDropdownMenus[spanText].style.display = "block";
    backButton.style.display = "flex";
  });
});
hamburgerButton.addEventListener("click", () => {
  drawer.classList.add("open");
});
backButton.addEventListener("click", () => {
  const mainMenu = document.querySelector(".menu-drawer__navigation");
  mainMenu.style.display = "block";
  backButton.style.display = "none";
  Object.values(storedDropdownMenus).forEach((dropdownMenu) => {
    dropdownMenu.style.display = "none";
    const originalParent = document.querySelector(".dropdown-mobile");
    originalParent.appendChild(dropdownMenu);
  });
});

// MEGA MENU MOBILE FUNCTIONALITY BELOW
document.addEventListener("DOMContentLoaded", function () {
  const menuDrawer = document.getElementById("menu-drawer");
  if (!menuDrawer) return;

  function createChevronSpan() {
    const chevronSpan = document.createElement("span");
    chevronSpan.innerHTML =
      '<svg width="8" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right:12px;"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.8839 1.11612C13.372 1.60427 13.372 2.39573 12.8839 2.88388L3.76777 12L12.8839 21.1161C13.372 21.6043 13.372 22.3957 12.8839 22.8839C12.3957 23.372 11.6043 23.372 11.1161 22.8839L1.11612 12.8839C0.881696 12.6495 0.75 12.3315 0.75 12C0.75 11.6685 0.881696 11.3505 1.11612 11.1161L11.1161 1.11612C11.6043 0.627961 12.3957 0.627961 12.8839 1.11612Z" fill="#FF0000"/></svg>';
    return chevronSpan;
  }

  function setBackButtonText(btn, text) {
    if (!btn) return;
    btn.innerHTML = "";
    btn.appendChild(createChevronSpan());
    btn.appendChild(document.createTextNode(text));
  }

  function resetAllMobileSubmenus() {
    const allRootItems = menuDrawer.querySelectorAll(".li-container.mobile");
    allRootItems.forEach((item) => (item.style.display = ""));

    const loginBox = menuDrawer.querySelector(".menu-drawer-login-container");
    if (loginBox) loginBox.classList.remove("menu-drawer__account--hidden");

    const wishlist = menuDrawer.querySelector(".wishlist-login-container");
    if (wishlist) wishlist.style.display = "flex";

    menuDrawer.querySelectorAll(".mega-menu-content-mobile").forEach((el) => (el.style.display = "none"));
    menuDrawer.querySelectorAll(".mega-menu-left-mobile").forEach((el) => (el.style.display = "none"));
    menuDrawer.querySelectorAll(".mega-menu-right-mobile").forEach((el) => (el.style.display = "none"));
    menuDrawer.querySelectorAll(".mega-menu-right-content.mobile").forEach((el) => (el.style.display = "none"));
    menuDrawer.querySelectorAll(".level-2-back").forEach((el) => (el.style.display = "none"));
    menuDrawer.querySelectorAll(".level-3-back").forEach((el) => (el.style.display = "none"));
  }

  // Handle clicking a top-level mega menu title (e.g. MUJER, HOMBRE, NIÑOS)
  const megaMenuTitles = menuDrawer.querySelectorAll(".mega-menu-title-mobile");
  megaMenuTitles.forEach((titleBtn) => {
    titleBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const wrapper = this.closest(".mega-menu-wrapper-mobile") || this.closest(".li-container.mobile");
      if (!wrapper) return;

      const titleText = this.querySelector("span") ? this.querySelector("span").innerText.trim() : this.innerText.trim();

      // Hide all root level menu items
      const allRootItems = menuDrawer.querySelectorAll(".li-container.mobile");
      allRootItems.forEach((item) => (item.style.display = "none"));

      const loginBox = menuDrawer.querySelector(".menu-drawer-login-container");
      if (loginBox) loginBox.classList.add("menu-drawer__account--hidden");

      const wishlist = menuDrawer.querySelector(".wishlist-login-container");
      if (wishlist) wishlist.style.display = "none";

      // Show active wrapper and Level 2
      wrapper.style.display = "block";
      const contentMobile = wrapper.querySelector(".mega-menu-content-mobile");
      const leftMobile = wrapper.querySelector(".mega-menu-left-mobile");
      const level2Back = wrapper.querySelector(".level-2-back");

      if (contentMobile) contentMobile.style.display = "flex";
      if (leftMobile) leftMobile.style.display = "block";
      if (level2Back) {
        level2Back.style.display = "flex";
        setBackButtonText(level2Back, titleText);
      }
    });
  });

  // Handle Level 2 option links (e.g. CATEGORÍAS, COLECCIONES)
  const megaOptions = menuDrawer.querySelectorAll(".mega-menu-option.mobile");
  megaOptions.forEach((optionBtn) => {
    optionBtn.addEventListener("click", function (e) {
      if (this.classList.contains("standard-option")) return;

      e.preventDefault();
      e.stopPropagation();

      const wrapper = this.closest(".mega-menu-wrapper-mobile") || this.closest(".li-container.mobile");
      if (!wrapper) return;

      const optionKey = this.dataset.option;
      const optionText = this.innerText.trim();

      const leftMobile = wrapper.querySelector(".mega-menu-left-mobile");
      const rightMobile = wrapper.querySelector(".mega-menu-right-mobile");
      const level2Back = wrapper.querySelector(".level-2-back");
      const level3Back = wrapper.querySelector(".level-3-back");

      if (leftMobile) leftMobile.style.display = "none";
      if (level2Back) level2Back.style.display = "none";

      if (rightMobile) {
        rightMobile.style.display = "block";
        const contents = rightMobile.querySelectorAll(".mega-menu-right-content.mobile");
        contents.forEach((c) => {
          if (c.dataset.content === optionKey) {
            c.style.display = "flex";
          } else {
            c.style.display = "none";
          }
        });
      }

      if (level3Back) {
        level3Back.style.display = "flex";
        setBackButtonText(level3Back, optionText);
      }
    });
  });

  // Handle Level 2 back button (return to Level 1 root drawer)
  const level2BackBtns = menuDrawer.querySelectorAll(".level-2-back");
  level2BackBtns.forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      resetAllMobileSubmenus();
    });
  });

  // Handle Level 3 back button (return to Level 2)
  const level3BackBtns = menuDrawer.querySelectorAll(".level-3-back");
  level3BackBtns.forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const wrapper = this.closest(".mega-menu-wrapper-mobile") || this.closest(".li-container.mobile");
      if (!wrapper) return;

      const leftMobile = wrapper.querySelector(".mega-menu-left-mobile");
      const rightMobile = wrapper.querySelector(".mega-menu-right-mobile");
      const level2Back = wrapper.querySelector(".level-2-back");

      if (rightMobile) rightMobile.style.display = "none";
      this.style.display = "none";

      if (leftMobile) leftMobile.style.display = "block";
      if (level2Back) level2Back.style.display = "flex";
    });
  });

  // Category and Collection accordion header toggles
  document.querySelectorAll(".mega-menu-category-list-title").forEach((title) => {
    title.addEventListener("click", () => {
      const menuItems = title.nextElementSibling;
      if (menuItems) {
        menuItems.style.display = menuItems.style.display === "none" ? "block" : "none";
      }
    });
  });

  document.querySelectorAll(".megamenu-collections-mobile-header").forEach((header) => {
    header.addEventListener("click", () => {
      const cardMenu = header.nextElementSibling;
      if (cardMenu) {
        cardMenu.style.display = cardMenu.style.display === "none" ? "flex" : "none";
      }
    });
  });

  // Reset menu drawer on clicking outside
  document.addEventListener("click", function (event) {
    if (
      !event.target.closest("#menu-drawer") &&
      !event.target.closest(".header__icon--menu")
    ) {
      resetAllMobileSubmenus();
    }
  });
});

// ANIMATION OF THE CLOSING OF THE MENU DRAWER
function closeMenuDrawerWithAnimation() {
  const menuDrawer = document.querySelector("#menu-drawer");
  const menuDrawerContainer = document.querySelector(".menu-drawer-container");
  const summary = document.querySelector("summary");
  summary.setAttribute("aria-expanded", "false");

  menuDrawer.animate(
    [
      {
        transform: "translateX(0)",
      },
      {
        transform: "translateX(-100%)",
      },
    ],
    {
      duration: 300,
      easing: "ease",
    }
  ).onfinish = () => {
    menuDrawerContainer.removeAttribute("open");
    menuDrawer.classList.remove("menu-opening");

    const submenuOpenElements =
      menuDrawerContainer.querySelectorAll(".submenu-open");
    submenuOpenElements.forEach(function (submenu) {
      submenu.classList.remove("submenu-open");
    });

    const bodyClassList = document.body.classList;
    const overflowHiddenClass = Array.from(bodyClassList).find((className) =>
      className.startsWith("overflow-hidden-")
    );
    if (overflowHiddenClass) {
      bodyClassList.remove(overflowHiddenClass);
    }
  };
}

// ADDITION OF CLOSING FUNCTIONALITY TO 'X' IN MENU DRAWER
document.addEventListener("DOMContentLoaded", function () {
  const closeButtons = document.querySelectorAll(".menu-drawer-close-wrapper");

  closeButtons.forEach((button) => {
    button.addEventListener("click", closeMenuDrawerWithAnimation);
  });
});

//ACCOUNT ICON BEHAVIOUR WHEN USER LOGGED IN
document.addEventListener("DOMContentLoaded", function () {
  const dropdownHeaderAccount = document.querySelector(
    ".dropdown-header-account"
  );
  const dropdownMenuAccount = document.querySelector(".dropdown-menu-account");

  if (dropdownMenuAccount) {
    const showDropdownMenu = () => {
      dropdownMenuAccount.style.opacity = "1";
      dropdownMenuAccount.style.visibility = "visible";
      dropdownMenuAccount.style.transform = "translate(0px, 0px)";
    };

    const hideDropdownMenu = () => {
      dropdownMenuAccount.style.opacity = "0";
      dropdownMenuAccount.style.visibility = "hidden";
      dropdownMenuAccount.style.transform = "translate(0px, 20px)";
    };

    dropdownHeaderAccount.addEventListener("mouseenter", showDropdownMenu);
    dropdownHeaderAccount.addEventListener("mouseleave", hideDropdownMenu);
    dropdownMenuAccount.addEventListener("mouseenter", showDropdownMenu);
    dropdownMenuAccount.addEventListener("mouseleave", hideDropdownMenu);
  }
});